import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import React from 'react';
import { Menu } from '@headlessui/react';

import { Category } from '../../../models/Category';
import NavBarCategory from './NavBarCategory';

type Props = {
  categories: Category[];
};

function NavBarCategories(props: Props) {
  return (
    <div className="mt-2 flex w-full transition-all duration-300 text-sm space-x-2 overflow-y-visible overflow-x-visible items-center justify-center z-10">
      {props.categories?.map((category) => (
        <Menu
          key={category.id}
          as="div"
          onMouseLeave={() => {
            const activeEl = document.activeElement;
            if (
              activeEl instanceof HTMLElement &&
              activeEl.tagName === 'BUTTON'
            ) {
              activeEl.blur();
            }
          }}
          className="relative inline-block text-left"
        >
          <NavBarCategory category={category} />
        </Menu>
      ))}
    </div>
  );
}

export default NavBarCategories;
